exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "page-restaurant .menu-view {\n  padding-left: 0 !important;\n  padding-right: 0 !important; }\n\npage-restaurant .swiper-container {\n  width: 100%;\n  height: auto;\n  padding-bottom: 10px; }\n\npage-restaurant .swiper-slide {\n  font-size: 18px;\n  width: 90%;\n  /* Center slide text vertically */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center; }\n\npage-restaurant .swiper-container-horizontal > .swiper-pagination-bullets, page-restaurant .swiper-pagination-custom, page-restaurant .swiper-pagination-fraction {\n  bottom: 0px; }\n\npage-restaurant .card-meal {\n  position: relative; }\n  page-restaurant .card-meal img {\n    height: 260px;\n    background-color: #ddd;\n    border-radius: .5rem .5rem 0 0; }\n  page-restaurant .card-meal img[class] {\n    width: 100%;\n    border-radius: .5rem .5rem 0 0; }\n\npage-restaurant .object-fit_cover {\n  -o-object-fit: cover;\n     object-fit: cover; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nikolay/Documents/GitHub/menu-web/src/app/pages/restaurant/restaurant.scss
// module id = ../../../../../src/app/pages/restaurant/restaurant.scss
// module chunks = main